<template>
  <div>
    <v-toolbar flat class="cactus-primary--toolbar">
      <v-btn color="primary" @click="showCreateDialog = true">Create Extracts</v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout class="pa-4">
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          class="elevation-1">
          <template v-slot:items="props">
            <td style="width: 80px;">{{props.item.extract_id}}</td>
            <td class="text-xs-left">
              {{props.item.created_date}}
            </td>
            <td class="text-xs-left">
              <span  v-if="props.item.researcher">{{props.item.researcher.first_name}}</span>
            </td>
            <td class="text-xs-left">
              <span  v-if="props.item.culture_medium">{{props.item.culture_medium.name}}</span>
            </td>
            <td class="text-xs-left">
              <span v-if="props.item.extraction_method">{{props.item.extraction_method.name}}</span>
            </td>
            <td class="text-xs-left">
              <span v-if="props.item.organization">{{props.item.organization.name}}</span>
            </td>
            <td class="text-xs-left" v-for="n in ['genus', 'species', 'strain']" :key="n">
              <span v-if="props.item.culture.taxonomy[0]">
                {{props.item.culture.taxonomy[0].tax[n]}}
              </span>
            </td>
            <td class="text-xs-left">
              {{extractAPI.filename(props.item)}}
            </td>
          </template>
        </v-data-table>
        <InfiniteLoading @infinite="scrollLoad" :identifier="infiniteLoaderId"></InfiniteLoading>
      </v-flex>
    </v-layout>
    <CreateExtract v-model="showCreateDialog" @save="reload"></CreateExtract>
  </div>
</template>

<script>
import ExtractAPI from '@/api/extract.js'
import InfiniteLoading from 'vue-infinite-loading'
import CreateExtract from './dialog--create-extract.vue'
import {mapState} from 'vuex'

export default {
  components: {
    InfiniteLoading,
    CreateExtract
  },
  data () {
    return {
      items: [],
      showCreateDialog: false,
      infiniteLoaderId: +new Date(),
      pagination: {
        perPage: 100,
        page: 0
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['user']),
    headers () {
      const fields = [
        'Extract ID',
        'Created Date',
        'Researcher',
        'Media',
        'Extraction Method',
        'Organization',
        'Genus',
        'Species',
        'Strain',
        'Suggested Mzml Filename'
      ]
      return fields.map((f) => ({text: f, value: f, sortable: false}))
    }
  },
  created () {
    this.extractAPI = ExtractAPI
  },
  methods: {
    reload () {
      /**
       * a hacky way of grabbing new data
       * from the API and triggering inifiniteLoader
       * to pull from the api.
       */
      this.infiniteLoaderId += 1 // resets the infinite loader when filters change
      this.pagination.page = 0
      this.items = []
    },
    async scrollLoad ($state) {
      // $state from infinite-loader component
      const extraParams = {
        limit: this.pagination.perPage,
        offset: this.pagination.page * this.pagination.perPage
      }
      const data = await this.getExtracts({extraParams})
      if (data.length) {
        this.items = [...this.items, ...data]
        this.pagination.page += 1
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    async getExtracts ({extraParams = {}} = {}) {
      const select = '*,researcher:researcher_id(*),extraction_method(*),organization(*),culture(culture_medium(*),taxonomy(tax))'
      const params = {
        order: 'extract_id.desc',
        select,
        ...extraParams
      }
      this.loading = true
      const {data} = await ExtractAPI.get({params})
      this.loading = false
      return data
    }
  }
}
</script>

<style>

</style>
